import { Divider } from '@/components/atoms/divider';
import Heading from '@/components/atoms/heading';
import { G2Badge } from '@/components/integrations/g2';
import { ProxywayBadge } from '@/components/integrations/proxyway';
import { TrustpilotBadge } from '@/components/integrations/trustpilot';

import IconGuaranteed from '~/svg/IconGuaranteed.svg';
import { getText } from '@/lib/i18n/i18n.server';

export type HomepageHeroProps = {
  title: string;
  description: React.ReactNode;
  buttons?: React.ReactNode;
  showMoneyBack?: boolean;
  featureList?: React.ReactNode;
};

export async function HomepageHero({
  buttons,
  title,
  description,
  featureList,
  showMoneyBack,
}: HomepageHeroProps) {
  const texts = await getText();

  return (
    <div className='flex w-full flex-row items-center'>
      <div className='flex w-full flex-col'>
        <div className='mb-5 flex items-center gap-4 md:mb-6 md:justify-center'>
          <TrustpilotBadge />
          <div className='!h-9'>
            <Divider
              showOnDark
              alignment='vertical'
              classNames={{ root: 'border-neutral-dark-N10' }}
            />
          </div>
          <G2Badge />
          <div className='!h-9'>
            <Divider
              showOnDark
              alignment='vertical'
              classNames={{ root: 'border-neutral-dark-N10 !h-9' }}
            />
          </div>
          <ProxywayBadge />
        </div>
        <Heading
          level='h1'
          classNames={{
            root: 'mb-6 md:text-center md:text-l md:leading-[88px] mb-5 md:mb-6 ',
          }}
        >
          {title}
        </Heading>
        {description}

        <div data-tracker-component='buttons'>{buttons}</div>
        {showMoneyBack && (
          <div className='flex items-center gap-3 pb-8 md:justify-center md:pb-9'>
            <IconGuaranteed className='text-success-S99' />
            <p className='text-body-s'>
              {texts.pricing_cards.money_back.money_back}
            </p>
          </div>
        )}
        {featureList && (
          <div className='flex flex-wrap items-center gap-x-9 gap-y-6 md:justify-around'>
            {featureList}
          </div>
        )}
      </div>
    </div>
  );
}
